import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DownloadSecureFileService } from '../../core/_services';

@Component({
  selector: 'app-excel-export-button',
  templateUrl: './excel-export-button.component.html',
  styleUrls: ['./excel-export-button.component.scss'],
})
export class ExcelExportButtonComponent implements OnInit {
  @Input() exporting = false;
  @Input() endpoint: string;
  @Input() searchOptions: any;

  constructor(private download: DownloadSecureFileService) {}

  ngOnInit(): void {}

  onExportToExcel() {
    this.exporting = true;
    this.download
      .downloadFile(this.endpoint + '/ExportToExcel', this.searchOptions)
      .subscribe(() => (this.exporting = false));
  }
}
